import { useSelector } from 'react-redux';

// project constants
import { appConfigMeta, type AppConfigRoot, type AppConfigData } from '@a1/shared';

/**
 * Gets the name of an entity.
 * @param id Entity id (key)
 * @param config App config
 * @returns Entity name (value) or id
 */
const getEntityName = (id: string, config?: AppConfigData): string =>
  config?.entities?.[id] || appConfigMeta?.entities?.[id as keyof typeof appConfigMeta.entities]?.value || id;

/**
 * Hook that returns the name of an entity without requiring appConfig as a parameter
 * @param id Entity id (key)
 * @returns Entity name (value) or id
 */
const useGetEntityName = (id: string): string => {
  const appConfig = useSelector((state: AppConfigRoot) => state.appConfig?.data);
  return getEntityName(id, appConfig);
};

export { getEntityName, useGetEntityName };
